export default __webpack_public_path__ + "static/media/BG.ef96677c.ico";